import { css } from 'styled-components';

export const base = css`
  grid-auto-flow: row;
  grid-auto-rows: max-content;
`;
